export default __webpack_public_path__ + "static/media/bannerBig8.2ada772f.png";